<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Invalidita Civile" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Invalidita:</label>
                            <span v-if="isReadOnly">{{ jsonDataInvaliditaCivile.invalidita }}</span>
                            <b-form-textarea v-else v-model="jsonDataInvaliditaCivile.invalidita" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Percentuale invalidita:</label>
                            <span v-if="isReadOnly">{{ jsonDataInvaliditaCivile.percentualeInvalidita }}</span>
                            <b-form-textarea v-else v-model="jsonDataInvaliditaCivile.percentualeInvalidita" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Indennita accompagnamento:</label>
                            <span v-if="isReadOnly">{{ jsonDataInvaliditaCivile.indennitaAccompagnamento }}</span>
                            <b-form-textarea v-else v-model="jsonDataInvaliditaCivile.indennitaAccompagnamento" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <label class="sa-label-data">Situazione Legge 68/69:</label>
                            <span v-if="isReadOnly">{{ jsonDataInvaliditaCivile.situazioneLegge6899 }}</span>
                            <b-form-textarea v-else v-model="jsonDataInvaliditaCivile.situazioneLegge6899" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Legge 104/92:</label>
                            <span v-if="isReadOnly">{{ jsonDataInvaliditaCivile.legge10492 }}</span>
                            <b-form-textarea v-else v-model="jsonDataInvaliditaCivile.legge10492" :readonly="isReadOnly" max-rows="3" rows="1"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataInvaliditaCivile: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    invalidita: "",
                    percentualeInvalidita: "",
                    indennitaAccompagnamento: "",
                    situazioneLegge6899: "",
                    legge10492: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataInvaliditaCivile: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaInvaliditaCivile: "/rsaschedarelazionesanitariainvaliditacivile",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaInvaliditaCivile() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaInvaliditaCivile + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaInvaliditaCivileSuccess, me.resultResponseSchedaRelazioneSanitariaInvaliditaCivileError);
        },

        resultResponseSchedaRelazioneSanitariaInvaliditaCivileSuccess(response) {
            let me = this;
            me.jsonDataInvaliditaCivile = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaInvaliditaCivileError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataInvaliditaCivile = {
                id: null,
                idAccettazione: this.idAccettazione,
                invalidita: "",
                percentualeInvalidita: "",
                indennitaAccompagnamento: "",
                situazioneLegge6899: "",
                legge10492: "",
            };
        },

        onInvaliditaCivile() {
            let me = this;
            me.jsonDataInvaliditaCivile.idAccettazione = me.idAccettazione;
            if (!me.jsonDataInvaliditaCivile.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaInvaliditaCivile, me.jsonDataInvaliditaCivile, me.saveSchedaRelazioneSanitariaInvaliditaCivileSuccessResponse, me.saveSchedaRelazioneSanitariaInvaliditaCivileErrorResponse);
        },
        saveSchedaRelazioneSanitariaInvaliditaCivileSuccessResponse() {},
        saveSchedaRelazioneSanitariaInvaliditaCivileErrorResponse() {
            console.error("Errore nel salvataggio invalidita civile:");
        },
    },
};
</script>
